module.exports = __webpack_public_path__ + "img/sg5.eefe24dd.png";